import React, { Component } from "react";
import { connect } from "react-redux";
import { PageHeader, Row, Col, Tabs, Checkbox, Tag, Empty, Spin, message, Tooltip, Badge } from "antd";
import { BulbOutlined, CalendarOutlined, PlayCircleOutlined, ReloadOutlined, StopOutlined, PlusOutlined } from "@ant-design/icons";
import moment from "moment";
import { ButtonItem, TourItem } from "../../../../Components/Items";
import SelectClientesItem from "../../../../Components/SelectClientesItem";
import SelectContratoCMMS from "../componentes/SelectContratoCMMS";
import CalendarioCMMS, { LeyendaCMMS } from "../componentes/CalendarioCMMS";
import DrawerPlanCMMS from "../componentes/DrawerPlanCMMS";
import ModalCalendarizarCMMS from "../componentes/ModalCalendarizarCMMS";
import ModalNoRealizadoCMMS from "../componentes/ModalNoRealizadoCMMS";
import ModalSugerirCMMS from "../componentes/ModalSugerirCMMS";
import ModalProgramarServicioCMMS from "../componentes/ModalProgramarServicioCMMS";
import FiltroIngenieroCMMS, { esperarFiltroDefault } from "../componentes/FiltroIngenieroCMMS";
import { calendarizarPlanes, noRealizarPlanes, cargarListasCMMS } from "../componentes/accionesPlanes";
import { cmmsPost, ESTATUS_PLAN, estatusPlan, formatoFecha, fechaDiaPayload } from "../cmmsComun";
import "../cmms.css";

// Agenda del CMMS: lo calendarizado en cada dia (planes de los contratos y de la agenda) y
// los servicios, mas lo que falta: equipos de contrato sin fecha en la vuelta vigente,
// atrasados y equipos sin contrato a los que ya les toca preventivo. Nada de aqui crea
// una Orden de Servicio salvo "Iniciar servicio". Lo que falta son sugerencias: para todos o,
// con "Sugerir a...", para un ingeniero (con filtro de ingeniero se ven las suyas y las de todos).

const COLOR_SERVICIO = { 1: "#7a8794", 2: "#2fb8d6", 3: "#2e9e6b", 0: "#d64545" };

class Agenda extends Component {
    refCalendario = React.createRef();
    refPanel = React.createRef();

    state = {
        cargando: false,
        rango: null,
        clienteId: null,
        contratoId: null,
        empleadoId: null,
        datos: { calendarizados: [], servicios: [], porCalendarizar: [], atrasados: [], sinContrato: [] },
        festivos: [],
        pestana: "porCalendarizar",
        seleccion: { porCalendarizar: [], atrasados: [], sinContrato: [] },
        plan: null,
        modalCalendarizar: null, // { lista, ids }
        modalNoRealizado: null,
        modalSugerir: null, // { lista, ids }
        // "Programar servicio" a cualquier equipo sin nada anterior: { fecha }
        modalProgramar: null,
        motivos: [],
        // Permiso "Mover en la agenda" (lo dice el backend con la agenda).
        puedeMover: true,
        openTour: false,
    };

    componentDidMount() {
        cargarListasCMMS(this.props).then((c) => this.setState({ motivos: c.motivosNoRealizado || [] }));
    }

    consultar = async (rango = this.state.rango) => {
        if (!rango) return;
        this.setState({ cargando: true, rango });
        try {
            // La primera vez arranca con el ingeniero que fijó el usuario.
            await esperarFiltroDefault(this);
            const res = await cmmsPost(this.props, "agendaCMMS", {
                desde: fechaDiaPayload(rango.desde),
                hasta: fechaDiaPayload(rango.hasta),
                clienteId: this.state.clienteId,
                contratoId: this.state.contratoId,
                empleadoId: this.state.empleadoId,
            });
            if (res.data.success === 2) {
                const { calendarizados, servicios, porCalendarizar, atrasados, sinContrato } = res.data;
                this.setState((s) => ({
                    puedeMover: res.data.puedeMover !== false,
                    festivos: res.data.festivos || [],
                    datos: { calendarizados, servicios, porCalendarizar, atrasados, sinContrato },
                    seleccion: { porCalendarizar: [], atrasados: [], sinContrato: [] },
                    plan: s.plan ? [...calendarizados, ...porCalendarizar, ...atrasados].find((p) => p._id === s.plan._id) || s.plan : null,
                }));
            } else message.error(res.data.message || "No se pudo consultar la agenda");
        } catch (error) {
            console.log(error);
            message.error("No se pudo consultar la agenda");
        } finally {
            this.setState({ cargando: false });
        }
    };

    filtrar = (cambios) => this.setState(cambios, () => this.consultar());

    eventos = () => {
        const { calendarizados, servicios } = this.state.datos;
        const delPlan = calendarizados.map((p) => ({
            id: p._id,
            tipo: "plan",
            plan: p,
            title: [p.activo?.codigo, p.tipoNombre].filter(Boolean).join(" · "),
            subtitulo: [p.sucursalNombre || p.clienteNombre, p.empleadoNombre || (p.estatus === 1 && !p.servicioId ? "Para todos" : "")].filter(Boolean).join(" · "),
            detalle: `${estatusPlan(p.estatusVisible).label}${p.contratoNombre ? ` · ${p.contratoNombre} ${p.vueltaNombre}` : ""}`,
            start: moment(String(p.fechaPlaneada).slice(0, 10)).toDate(),
            end: moment(String(p.fechaPlaneada).slice(0, 10)).toDate(),
            color: estatusPlan(p.estatusVisible).hex,
            arrastrable: this.state.puedeMover && !p.contratoCancelado && ((p.estatus === 1 && !p.servicioId) || p.estatus === 3),
        }));
        const deServicios = servicios
            .filter((s) => s.fecha)
            .map((s) => ({
                id: `s${s._id}`,
                tipo: "servicio",
                servicio: s,
                title: `${s.codigo} · ${s.activoTexto}`,
                subtitulo: [s.clienteNombre, s.empleadoNombre].filter(Boolean).join(" · "),
                detalle: `${s.tipoServicioNombre} · ${s.estatusNombre}`,
                start: moment(s.fecha).startOf("day").toDate(),
                end: moment(s.fecha).startOf("day").toDate(),
                color: COLOR_SERVICIO[s.estatus] || "#7a8794",
                arrastrable: false,
            }));
        // Dias festivos (Viajes > Dias festivos): tambien se saltan al repartir el programa.
        const festivos = (this.state.festivos || []).map((f) => ({
            id: `f${f.fecha}`,
            tipo: "festivo",
            title: "Día festivo",
            subtitulo: f.nombre,
            start: moment(f.fecha, "YYYY-MM-DD").toDate(),
            end: moment(f.fecha, "YYYY-MM-DD").toDate(),
            color: "#9aa7b4",
            arrastrable: false,
        }));
        return [...festivos, ...delPlan, ...deServicios];
    };

    // El renglon cuando se calendariza / sugiere uno solo (para mostrar su ingeniero actual).
    unicoSeleccionado = (m) => {
        if (!m || m.ids.length !== 1) return null;
        return (this.state.datos[m.lista] || []).find((x) => x._id === m.ids[0]) || null;
    };

    mover = async (evento, fecha) => {
        if (await calendarizarPlanes(this.props, [evento.plan._id], { fecha, cambiarEmpleado: false })) this.consultar();
    };

    alternar = (lista, id) =>
        this.setState((s) => {
            const actual = s.seleccion[lista];
            return { seleccion: { ...s.seleccion, [lista]: actual.includes(id) ? actual.filter((x) => x !== id) : [...actual, id] } };
        });

    // Equipos sin contrato: se agregan a la agenda (crea su renglon con fecha, o le pone fecha a
    // su sugerencia; si no se cambia el ingeniero se queda con el que se le sugirio).
    agendarSinContrato = async (ids, datos) => {
        let ok = 0;
        for (const activoId of ids) {
            const res = await cmmsPost(this.props, "agregarPlanAgendaCMMS", {
                activoId,
                fechaPlaneada: fechaDiaPayload(datos.fecha),
                cambiarEmpleado: !!datos.cambiarEmpleado,
                empleadoId: datos.cambiarEmpleado ? datos.empleadoId : null,
                tipoServicio: datos.tipoServicio,
                notas: datos.notas,
            });
            if (res.data.success === 2) ok++;
            else message.error(res.data.message || "No se pudo agendar");
        }
        if (ok) message.success(`${ok} equipo(s) agregados a la agenda`);
        return ok > 0;
    };

    renderLista(lista) {
        const elementos = this.state.datos[lista] || [];
        const seleccion = this.state.seleccion[lista];
        if (!elementos.length)
            return (
                <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description={
                        lista === "porCalendarizar"
                            ? "Todo lo de las vueltas vigentes ya tiene fecha"
                            : lista === "atrasados"
                            ? "No hay servicios atrasados"
                            : "Ningún equipo sin contrato tiene preventivo vencido o por vencer en este periodo"
                    }
                />
            );
        const esActivo = lista === "sinContrato";
        const esSugerencia = lista !== "atrasados";
        // Los atrasados ya tienen fecha: reprogramarlos es moverlos (sin permiso solo el ingeniero).
        const fechaFija = lista === "atrasados" && !this.state.puedeMover;
        return (
            <>
                <div className="cmms-agenda-acciones">
                    <Checkbox
                        checked={seleccion.length === elementos.length}
                        indeterminate={seleccion.length > 0 && seleccion.length < elementos.length}
                        onChange={(e) => this.setState((s) => ({ seleccion: { ...s.seleccion, [lista]: e.target.checked ? elementos.map((x) => x._id) : [] } }))}
                    >
                        {seleccion.length ? `${seleccion.length} seleccionados` : "Todos"}
                    </Checkbox>
                    <span style={{ display: "flex", gap: 4, flexWrap: "wrap", justifyContent: "flex-end" }}>
                        <ButtonItem type="primary" size="small" icon={<CalendarOutlined />} disabled={!seleccion.length} onClick={() => this.setState({ modalCalendarizar: { lista, ids: seleccion } })}>
                            {fechaFija ? "Cambiar ingeniero" : lista === "atrasados" ? "Reprogramar" : "Calendarizar"}
                        </ButtonItem>
                        {esSugerencia && (
                            <Tooltip title="Sugerirlos a un ingeniero o a todos, sin ponerles fecha">
                                <ButtonItem type="default" size="small" blanco icon={<BulbOutlined />} disabled={!seleccion.length} onClick={() => this.setState({ modalSugerir: { lista, ids: seleccion } })}>
                                    Sugerir a...
                                </ButtonItem>
                            </Tooltip>
                        )}
                        {!esActivo && (
                            <ButtonItem type="default" size="small" rojo icon={<StopOutlined />} disabled={!seleccion.length} onClick={() => this.setState({ modalNoRealizado: { ids: seleccion } })}>
                                No realizado
                            </ButtonItem>
                        )}
                    </span>
                </div>
                <div className="cmms-agenda-lista">
                    {elementos.map((x) => (
                        <div key={x._id} className={`cmms-agenda-item ${seleccion.includes(x._id) ? "sel" : ""}`}>
                            <Checkbox checked={seleccion.includes(x._id)} onChange={() => this.alternar(lista, x._id)} />
                            <div style={{ flex: 1, minWidth: 0, cursor: esActivo ? "default" : "pointer" }} onClick={() => !esActivo && this.setState({ plan: x })}>
                                <div className="cmms-agenda-item-titulo">{x.activoTexto}</div>
                                <div className="cmms-agenda-item-sub">
                                    {[x.clienteNombre, x.sucursalNombre, esActivo ? null : x.contratoNombre && `${x.contratoNombre} · ${x.vueltaNombre}`].filter(Boolean).join(" · ")}
                                </div>
                                <div className="cmms-agenda-item-sub">
                                    {esActivo && x.fechaProximoPreventivo ? (
                                        <Tag color={x.vencido ? "red" : "gold"}>
                                            {x.vencido ? "Vencido" : "Por vencer"}: {formatoFecha(x.fechaProximoPreventivo)}
                                        </Tag>
                                    ) : lista === "atrasados" ? (
                                        <Tag color="orange">Era para el {formatoFecha(x.fechaPlaneada)}</Tag>
                                    ) : null}
                                    {esSugerencia ? (
                                        x.empleadoId ? (
                                            <Tag color="blue" icon={<BulbOutlined />}>
                                                Para: {x.empleadoNombre || "ingeniero"}
                                            </Tag>
                                        ) : (
                                            <Tag icon={<BulbOutlined />}>Para todos</Tag>
                                        )
                                    ) : x.empleadoNombre ? (
                                        <span>{x.empleadoNombre}</span>
                                    ) : (
                                        <Tag icon={<BulbOutlined />}>Para todos</Tag>
                                    )}
                                </div>
                            </div>
                            <Tooltip title="Iniciar servicio">
                                <ButtonItem
                                    type="default"
                                    size="small"
                                    cyan
                                    icon={<PlayCircleOutlined />}
                                    onClick={() =>
                                        this.props.history.push("/panel/cmmsServicio", esActivo ? (x.sugerenciaId ? { planId: x.sugerenciaId } : { activoId: x._id }) : { planId: x._id })
                                    }
                                />
                            </Tooltip>
                        </div>
                    ))}
                </div>
            </>
        );
    }

    render() {
        const { datos, modalCalendarizar } = this.state;
        const leyenda = ["calendarizado", "atrasado", "enProceso", "realizado", "noRealizado"].map((k) => ({ label: ESTATUS_PLAN[k].label, hex: ESTATUS_PLAN[k].hex }));
        if ((this.state.festivos || []).length) leyenda.push({ label: "Día festivo", hex: "#9aa7b4" });
        return (
            <div className="cmms-pagina">
                <PageHeader
                    title="Agenda"
                    subTitle="Lo calendarizado y lo que falta por atender"
                    style={{ border: "1px solid rgb(235, 237, 240)", backgroundColor: "white", marginBottom: 10 }}
                    extra={
                        <>
                            <ButtonItem type="primary" icon={<PlusOutlined />} onClick={() => this.setState({ modalProgramar: { fecha: moment() } })}>
                                Programar servicio
                            </ButtonItem>
                            <ButtonItem type="default" icon={<ReloadOutlined />} onClick={() => this.consultar()}>
                                Actualizar
                            </ButtonItem>
                            <ButtonItem type="link" blanco onClick={() => this.setState({ openTour: true })}>
                                ¿Cómo funciona?
                            </ButtonItem>
                        </>
                    }
                />
                <div className="cmms-filtros">
                    <div style={{ width: 260 }}>
                        <SelectClientesItem
                            empresaId={this.props.empresaId}
                            headersToken={this.props.headersToken}
                            placeholder="Todos los clientes"
                            allowClear
                            width="100%"
                            value={this.state.clienteId || undefined}
                            onChange={(clienteId) => this.filtrar({ clienteId: clienteId || null, contratoId: null })}
                        />
                    </div>
                    <div style={{ width: 260 }}>
                        <SelectContratoCMMS {...this.props} clienteId={this.state.clienteId} value={this.state.contratoId} onChange={(contratoId) => this.filtrar({ contratoId })} />
                    </div>
                    <FiltroIngenieroCMMS {...this.props} width={290} value={this.state.empleadoId} onChange={(empleadoId) => this.filtrar({ empleadoId })} />
                </div>
                <Row gutter={12}>
                    <Col xs={24} xl={17}>
                        <div ref={this.refCalendario}>
                            <Spin spinning={this.state.cargando}>
                                <CalendarioCMMS
                                    events={this.eventos()}
                                    onRango={(r) => this.consultar(r)}
                                    onMover={this.mover}
                                    onDiaClick={(fecha) => this.setState({ modalProgramar: { fecha } })}
                                    textoNuevo="+ Programar"
                                    onSeleccionar={(e) =>
                                        e.tipo === "plan" ? this.setState({ plan: e.plan }) : e.tipo === "servicio" ? this.props.history.push("/panel/cmmsServicio", { id: e.servicio._id }) : null
                                    }
                                    leyenda={<LeyendaCMMS items={leyenda} />}
                                />
                            </Spin>
                        </div>
                    </Col>
                    <Col xs={24} xl={7}>
                        <div className="cmms-agenda-panel" ref={this.refPanel}>
                            <Tabs activeKey={this.state.pestana} onChange={(pestana) => this.setState({ pestana })} size="small">
                                <Tabs.TabPane
                                    key="porCalendarizar"
                                    tab={
                                        <span>
                                            Por calendarizar <Badge count={datos.porCalendarizar.length} overflowCount={999} style={{ backgroundColor: "#9aa7b4" }} />
                                        </span>
                                    }
                                >
                                    <div className="cmms-ayuda">Equipos de contrato que en la vuelta vigente todavía no tienen fecha. Son para todos los ingenieros salvo que se le sugieran a uno.</div>
                                    {this.renderLista("porCalendarizar")}
                                </Tabs.TabPane>
                                <Tabs.TabPane
                                    key="atrasados"
                                    tab={
                                        <span>
                                            Atrasados <Badge count={datos.atrasados.length} overflowCount={999} style={{ backgroundColor: "#e8833a" }} />
                                        </span>
                                    }
                                >
                                    <div className="cmms-ayuda">Su fecha ya pasó y no se ha hecho el servicio. Reprograme o márquelos como no realizados.</div>
                                    {this.renderLista("atrasados")}
                                </Tabs.TabPane>
                                <Tabs.TabPane
                                    key="sinContrato"
                                    tab={
                                        <span>
                                            Sin contrato <Badge count={datos.sinContrato.length} overflowCount={999} style={{ backgroundColor: "#d9962b" }} />
                                        </span>
                                    }
                                >
                                    <div className="cmms-ayuda">Equipos sin contrato vigente cuyo próximo preventivo (por la periodicidad de su tipo) ya venció o vence en este periodo, o que ya se le sugirieron a un ingeniero.</div>
                                    {this.renderLista("sinContrato")}
                                </Tabs.TabPane>
                            </Tabs>
                        </div>
                    </Col>
                </Row>

                <DrawerPlanCMMS
                    {...this.props}
                    visible={!!this.state.plan}
                    plan={this.state.plan}
                    puedeMover={this.state.puedeMover}
                    motivos={this.state.motivos}
                    onClose={() => this.setState({ plan: null })}
                    onCambio={(soloTexto) => this.setState(soloTexto ? {} : { plan: null }, () => this.consultar())}
                />
                <ModalCalendarizarCMMS
                    {...this.props}
                    visible={!!modalCalendarizar}
                    titulo={modalCalendarizar?.lista === "sinContrato" ? "Agregar a la agenda" : modalCalendarizar?.lista === "atrasados" ? "Reprogramar" : "Calendarizar"}
                    cantidad={modalCalendarizar?.ids.length || 0}
                    empleadoInicial={this.unicoSeleccionado(modalCalendarizar)?.empleadoId}
                    conTipoServicio={modalCalendarizar?.lista === "sinContrato"}
                    fechaBloqueada={modalCalendarizar?.lista === "atrasados" && !this.state.puedeMover}
                    fechaObligatoria
                    onCancel={() => this.setState({ modalCalendarizar: null })}
                    onAceptar={async (d) => {
                        const ok =
                            modalCalendarizar.lista === "sinContrato"
                                ? await this.agendarSinContrato(modalCalendarizar.ids, d)
                                : await calendarizarPlanes(this.props, modalCalendarizar.ids, d);
                        if (ok) this.setState({ modalCalendarizar: null }, () => this.consultar());
                    }}
                />
                <ModalSugerirCMMS
                    {...this.props}
                    visible={!!this.state.modalSugerir}
                    cantidad={this.state.modalSugerir?.ids.length || 0}
                    planesIds={this.state.modalSugerir?.lista === "porCalendarizar" ? this.state.modalSugerir.ids : []}
                    activosIds={this.state.modalSugerir?.lista === "sinContrato" ? this.state.modalSugerir.ids : []}
                    empleadoInicial={this.unicoSeleccionado(this.state.modalSugerir)?.empleadoId}
                    onCancel={() => this.setState({ modalSugerir: null })}
                    onListo={() => this.setState({ modalSugerir: null }, () => this.consultar())}
                />
                <ModalProgramarServicioCMMS
                    {...this.props}
                    visible={!!this.state.modalProgramar}
                    fechaInicial={this.state.modalProgramar?.fecha}
                    onCerrar={(ok) => this.setState({ modalProgramar: null }, () => ok && this.consultar())}
                />
                <ModalNoRealizadoCMMS
                    visible={!!this.state.modalNoRealizado}
                    cantidad={this.state.modalNoRealizado?.ids.length || 0}
                    motivos={this.state.motivos}
                    onCancel={() => this.setState({ modalNoRealizado: null })}
                    onAceptar={async (motivo) => {
                        if (await noRealizarPlanes(this.props, this.state.modalNoRealizado.ids, motivo)) this.setState({ modalNoRealizado: null }, () => this.consultar());
                    }}
                />
                <TourItem
                    open={this.state.openTour}
                    onClose={() => this.setState({ openTour: false })}
                    steps={[
                        {
                            title: "La agenda sugiere, no crea",
                            description:
                                "Aquí se ve qué toca atender cada día. Calendarizar o mover algo NO crea la Orden de Servicio: ésta nace cuando el ingeniero da 'Iniciar servicio' en sitio. Así no se acumulan servicios futuros que a veces no se hacen.",
                            target: null,
                        },
                        {
                            title: "Calendario",
                            description:
                                "Cada tarjeta es un equipo calendarizado (color por estatus) o una Orden de Servicio. Arrastre una tarjeta a otro día para reprogramarla; dé clic para ver el detalle, iniciar el servicio o marcarlo como no realizado.",
                            target: () => this.refCalendario.current,
                        },
                        {
                            title: "Programar un servicio",
                            description:
                                "Con 'Programar servicio' (o dando clic en un día vacío) se le pone un servicio a cualquier equipo ese día, sin que venga de un contrato ni de una sugerencia: equipo, tipo de servicio, ingeniero y notas.",
                            target: () => this.refCalendario.current,
                        },
                        {
                            title: "Lo que falta",
                            description:
                                "Por calendarizar: equipos de contrato sin fecha en la vuelta vigente. Atrasados: su fecha ya pasó. Sin contrato: equipos a los que ya les toca preventivo. Seleccione varios y calendarícelos juntos.",
                            target: () => this.refPanel.current,
                        },
                        {
                            title: "Sugerencias para todos o para uno",
                            description:
                                "Lo que falta es para todos los ingenieros. Con 'Sugerir a...' se le dirige a uno solo, sin ponerle fecha: él lo ve en su agenda y en Mis servicios. Al filtrar por un ingeniero se ven sus sugerencias y las que son para todos.",
                            target: () => this.refPanel.current,
                        },
                        {
                            title: "Ver siempre sólo lo mío",
                            description:
                                "Elija un ingeniero en el filtro (por ejemplo, usted) y dé clic en la chincheta: en todo el CMMS arrancará viendo sólo lo suyo. Se puede quitar el filtro cuando quiera ver todo.",
                            target: null,
                        },
                    ]}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(Agenda);
